// Utility layer (TS-2.5.04). The recovered reference generator computes its legend as
// "present = [s for s in statuses if any(...)]" against a fixed canonical order - the ordering
// was the hardcoded part decomposition.md section 8.7 point 9 flags for correction. This module
// keeps "only statuses actually on the board" (still data-driven, from the board itself, so a
// status that exists in the vocabulary but has zero live projects never appears) while sourcing
// the ORDER from RoadmapFilterOptions.statuses[].displayOrder - reference-data an admin controls
// (A-9) - rather than any literal array in this codebase.
import type { FilterChoice, RoadmapBoard } from "../../../api/generated/contracts";

export interface LegendEntry {
  readonly label: string;
  readonly colorHex: string;
}

export function buildLegend(board: RoadmapBoard, statuses: readonly FilterChoice[]): readonly LegendEntry[] {
  const orderByLabel = new Map(statuses.map((choice) => [choice.label, choice.displayOrder]));
  const colorByLabel = new Map<string, string>();

  for (const lane of board.swimlanes) {
    for (const chip of lane.chips) {
      if (!colorByLabel.has(chip.statusCanonical)) {
        colorByLabel.set(chip.statusCanonical, chip.colorHex);
      }
    }
  }

  return Array.from(colorByLabel.entries())
    .map(([label, colorHex]) => ({ label, colorHex, order: orderByLabel.get(label) ?? Number.MAX_SAFE_INTEGER }))
    .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label))
    .map(({ label, colorHex }) => ({ label, colorHex }));
}
